import { IApplicationState } from '../../../../../types/types';

export const isSettingsOpenedSelector = (state: IApplicationState) => state.cookieDialog.isSettingsOpened;
